/* To ensure the site is compliant with local regulations (China), 
we have added ICP/MPS registration number under China EDP/MIQ’s landing page */
export const ICP_CHINA = { text: '京ICP备17042425号-3', URL: 'http://beian.miit.gov.cn/' };
export const PUBLIC_NETWORK_SECURITY_CHINA = {
  text: '京公网安备 11010502042366',
  URL: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042366',
};
